const ResetPasswordValidationRules = {
    phone:'required|max:20',
    password:'required|min:8|confirmed',
    password_confirmation:'required'
};

export default ResetPasswordValidationRules;